import { addLineItemToTransaction } from 'src/home-page/business-logic/sale-mode-router';
import { LineModifiersMethodCodes } from '../../common/enumerations/line-modifiers-methods';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { getLineItem } from '../../items-list/business-logic/line-item-builder';

// department sale do not need data info and itemlookup, and it uses a simple sale route
export const sellDepartmentItem = async (
  inputData: IItemInputData,
  newPrice: number,
): Promise<void> => {
  const lineItem = getLineItem(inputData);
  // TODO handle electriItem
  // lineItemToAdd.SerialNumber = electronicItemDataModel.ExternalId;
  lineItem.modifiers = [LineModifiersMethodCodes.RequiredPrice];
  lineItem.isDepartment = true;
  lineItem.newPrice = Number(newPrice);

  return addLineItemToTransaction({ lineItem, inputData, itemLookup: {} });
};
